<ng-container *ngIf="mapControls$ | async as mapControls">
  <div class="map page-container match-parent" id="parcel-map">
    <div [ngClass]="drawer.opened ? 'map-controls-container drawer-open' : 'map-controls-container drawer-closed'">
      <div class="controls-container-left">
        @if (readOnlyMap || isAdmin) {
          <div (click)="handleSiteDetailsClick()" class="heading command" data-cy="site-details">
            <fa-icon [icon]="['far', 'arrow-left']"></fa-icon>
            View Site Details
          </div>
          <div (click)="handleViewStandsClick()" class="heading command" data-cy="view-stands">
            <span>View Stands</span>
          </div>
        }
      </div>
      <div class="controls-container-center">
        <div class="search-bar match-parent">
          <div class="reverse-location-container"></div>
        </div>
      </div>
      <div class="controls-container-right">
        <div class="heading horizontal-padding">Layers</div>
        <div class="controls">
          <div
            #tooltip1="matTooltip"
            (click)="toggleMapControlsEvent('displayRoads'); tooltip1.toggle()"
            [ngClass]="mapControls.displayRoads ? 'active round show-desktop' : 'inactive round show-desktop'"
            class="icon-container"
            matTooltip="Roads"
            matTooltipClass="fc-tooltip-map">
            <fa-icon [icon]="['fas', 'road']"></fa-icon>
          </div>
          <div
            #tooltip2="matTooltip"
            (click)="toggleMapControlsEvent('displayWaterways'); tooltip2.toggle()"
            [ngClass]="mapControls.displayWaterways ? 'active round show-desktop' : 'inactive round show-desktop'"
            class="icon-container"
            matTooltip="Rivers and Streams"
            matTooltipClass="fc-tooltip-map">
            <fa-icon [icon]="['fas', 'water']"></fa-icon>
          </div>
        </div>
        <div class="heading horizontal-padding right">
          <fa-icon
            #tooltip11="matTooltip"
            *ngIf="isAdmin && !readOnlyMap"
            (click)="openKMLDialog(); tooltip11.toggle()"
            [icon]="['fal', 'layer-plus']"
            class="kml-icon-wrapper gray size-20 clickable"
            matTooltip="Add Parcel Using KML"
            matTooltipClass="fc-tooltip-map"></fa-icon>
        </div>
      </div>
    </div>
    <div *ngIf="showZoomInNote" class="zoom-in">
      <div class="header">Zoom In To See Property Boundaries</div>
      <div class="message">Use the plus icon to the left to get closer</div>
    </div>
    <div class="disclaimer">
      This map is not intended for other uses and should not be considered an accurate representation for boundary
      location or parcel bounds. Parcel data has been provided by Regrid.
    </div>
  </div>
</ng-container>

<input #documentUpload accept=".kml,.kmz" id="documentUpload" name="documentUpload" style="display: none" type="file" />
